import { FunctionComponent } from 'react'
import { ChevronRight } from '@mui/icons-material'
import { Box, Button, rucksack, Typography } from '@black-bear-energy/rucksack'
import { ChecklistCategoryAPIResponse } from '@black-bear-energy/black-bear-energy-common'

const categoryColors = {
  [ChecklistCategoryAPIResponse.Contracts]: rucksack.palette.info.main,
  [ChecklistCategoryAPIResponse.Construction]: '#00C853', // Green A700 from Material Design
} satisfies Record<ChecklistCategoryAPIResponse, string>

const categoryLabels = {
  [ChecklistCategoryAPIResponse.Contracts]: 'Contracts Checklist',
  [ChecklistCategoryAPIResponse.Construction]: 'Construction Checklist',
} satisfies Record<ChecklistCategoryAPIResponse, string>

interface ChecklistCategoryButtonProps {
  category: ChecklistCategoryAPIResponse
  onClick: () => void
}

export const ChecklistCategoryButton: FunctionComponent<
  ChecklistCategoryButtonProps
> = ({ category, onClick }) => {
  const textColor = rucksack.palette.success.contrastText

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        backgroundColor: categoryColors[category],
        borderRadius: rucksack.shape.borderRadius,
        paddingX: 2,
        paddingY: 1.5,
        width: '320px',
        cursor: 'pointer',
      }}
      onClick={onClick}
    >
      <Typography
        sx={{ color: textColor, flex: 1, fontSize: '1rem', fontWeight: 500 }}
      >
        {categoryLabels[category]}
      </Typography>
      <Button
        variant="text"
        size="small"
        endIcon={<ChevronRight />}
        sx={{ color: textColor, minWidth: 'auto' }}
      >
        View
      </Button>
    </Box>
  )
}
